const getQueryData = ({ queryId, queryList }) => {
  const query = queryList.find(q => q.id === queryId);
  return query
    ? { description: query.description, jiraId: query.jiraId }
    : { description: '', jiraId: '' };
};

const mapToJobQuery = ({ query, queryList }) => {
  const { description, jiraId } = getQueryData({
    queryId: query.id,
    queryList,
  });
  return {
    id: query.id,
    groupId: query.groupId,
    jiraId,
    description,
    executionTimeMs: query.executionTimeMs,
    tenantsCount: query.tenantsCount,
    tenantsAffected: {
      tenantsCount: query.tenantsAffected.tenantsCount,
      recordsCount: query.tenantsAffected.recordsCount,
    },
  };
};

export const mapToJobQueries = ({ queries, queryList }) => {
  const flattenedQueryList = queryList.flatMap(group =>
    group.queries.map(query => ({
      ...query,
      groupId: group.id,
    })),
  );

  return queries.map(query =>
    mapToJobQuery({ query, queryList: flattenedQueryList }),
  );
};
